import { render, staticRenderFns } from "./MoveLayer.vue?vue&type=template&id=978b8330&"
import script from "./MoveLayer.vue?vue&type=script&lang=js&"
export * from "./MoveLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('978b8330')) {
      api.createRecord('978b8330', component.options)
    } else {
      api.reload('978b8330', component.options)
    }
    module.hot.accept("./MoveLayer.vue?vue&type=template&id=978b8330&", function () {
      api.rerender('978b8330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/components/layer/MoveLayer.vue"
export default component.exports